import { render } from "./form.vue?vue&type=template&id=db83312c&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=db83312c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-db83312c"

export default script